var exports = {
  "kL": "xe533113f--01747c--container",
  "W2": "xe533113f--01747c--scroll",
  "Sl": "xe533113f--01747c--image",
  "UE": "xe533113f--01747c--arrow",
  "m0": "xe533113f--01747c--arrow-left",
  "tS": "xe533113f--01747c--arrow-right",
};

module.exports = exports;
